export default __webpack_public_path__ + "static/media/superheroes.66e761bd.gif";